import request from '@/utils/request'
// 问诊列表
export function getConsultList(data) {
  return request({
    url: '/health-cure/cure/consult/page/eval',
    method: 'get',
    params: data
  })
}
// 问诊评价
export function goEvaluate(data) {
  return request({
    url: '/health-cure/cure/ef-evaluation/update',
    method: 'post',
    data
  })
}
// 查询问诊评分
export function getEvaluation(data) {
  return request({
    url: '/health-cure/cure/ef-evaluation/detail',
    method: 'get',
    params: data
  })
}

// 完成工单的咨询弹窗信息
export function getConsultInfo(data) {
  return request({
    url: '/health-cure/cure/consult-reservation/getConfirmAppointmentByConsultId',
    method: 'get',
    params: data
  })
}

//确认通话时间
export function confirmConsultTime(data) {
  return request({
    url: '/health-cure/cure/consult-reservation/confirm/time',
    method: 'post',
    data
  })
}

// 【新】查询医生问诊备注
export function getConsultInfoRemark(data) {
  return request({
    url: '/health-cure/cure/consult-fee/remark',
    method: 'get',
    params: data
  })
}

// 根据工单ID获取咨询ID
export function getConsultIdByWorkOrderId(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getConsultIdByWorkOrderId',
    method: 'get',
    params: data
  })
}
